/**
 * 导航模块
 * 包含：当前页面导航高亮、汉堡菜单、Header 滚动收缩
 */

/**
 * 当前页面导航高亮
 */
function highlightCurrentNav() {
  const currentPath = window.location.pathname;
  const navLinks = document.querySelectorAll('.nav-menu a, .mobile-nav a');

  navLinks.forEach(link => {
    const linkPath = link.getAttribute('href');

    if (currentPath === linkPath) {
      link.classList.add('active');
    } else if (linkPath === '/' && (currentPath === '/' || currentPath === '')) {
      link.classList.add('active');
    } else if (linkPath === '/products' && currentPath.startsWith('/products/')) {
      link.classList.add('active');
    } else if (linkPath === '/news' && currentPath.startsWith('/news/')) {
      link.classList.add('active');
    }
  });
}

/**
 * 汉堡菜单
 */
function initHamburgerMenu() {
  const hamburger = document.querySelector('.hamburger-menu');
  const mobileNav = document.querySelector('.mobile-nav');
  const overlay = document.querySelector('.overlay');

  if (!hamburger || !mobileNav || !overlay) return;

  function toggleMenu() {
    hamburger.classList.toggle('active');
    mobileNav.classList.toggle('active');
    overlay.classList.toggle('active');
    document.body.style.overflow = hamburger.classList.contains('active') ? 'hidden' : '';
  }

  hamburger.addEventListener('click', toggleMenu);
  overlay.addEventListener('click', toggleMenu);

  document.querySelectorAll('.mobile-nav a').forEach(link => {
    link.addEventListener('click', toggleMenu);
  });
}

/**
 * Header 滚动收缩效果
 */
function initHeaderScroll() {
  const header = document.querySelector('header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, { passive: true });
}

/**
 * 初始化导航模块
 */
export function initNavigation() {
  highlightCurrentNav();
  initHamburgerMenu();
  initHeaderScroll();
}
